'use strict';

angular.module('lingApp')
  .filter('i18n', function ($rootScope, RipContext) {
    var indexRegExp = /\{([0-9]+)\}/g;

    return function (key, params) {
      var value = RipContext.i18nMap[key] || key;

      if (angular.isDefined(params)) {
        if (!angular.isArray(params)) {
          params = Array.prototype.slice.call(arguments, 1);
        }

        if (0 < params.length) {
          value = value.replace(indexRegExp, function(match, p1) {
            return params[p1];
          });
        }
      }

      return value;
    };
  })

  .factory('i18n', function($filter) {
    return $filter('i18n');
  });
